
import ContentService from './../services/content.service';
import { defineComponent, reactive } from 'vue';
import OfferingsService from './../services/offerings.service';
import store from './../store/store';

export default defineComponent({
  name: 'MainPage',
  data: () => {
    return {
      store: reactive(store)
    };
  },
  async mounted() {
    store.resetAll();

    try {
      const contentResponse = await ContentService.getContent();
      store.loadContent(contentResponse.content);
      try {
        const offeringsResponse = await OfferingsService.getOfferings();
        store.loadOfferings(offeringsResponse);
      } catch (error) {
        store.errorLoadingOfferings();
      }
    } catch (error) {
      store.errorLoadingContent();
    }
  }
});
